import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Recognition } from './components/Recognition';
import { CostOfStaying } from './components/CostOfStaying';
import { SystemPhases } from './components/SystemPhases';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-full bg-cream-50" data-id="element-0" data-mp="28u5ysp4wd9dw">
      <TopBar data-id="element-1" data-mp="28sl32w6ujkeg" />
      <Hero data-id="element-2" data-mp="28sbad0uf2z52" />
      <main data-id="element-3" data-mp="23vcjqs9ypabm">
        <Recognition data-id="element-4" data-mp="23vktwcepa1j4" />
        <CostOfStaying data-id="element-5" data-mp="23u9tmmkgrbwr" />
        <SystemPhases data-id="element-6" data-mp="23utadzydnu97" />
        <Volumes data-id="element-7" data-mp="23ti864kkyuk7" />
        <Bonuses data-id="element-8" data-mp="3ik7g4ghnibqn" />
        <Offer data-id="element-9" data-mp="3ikr0s4yore8d" />
        <Testimonials data-id="element-10" data-mp="3ij652c0mxp8x" />
        <Guarantee data-id="element-11" data-mp="3ijpcuzwkmx98" />
        <Faq data-id="element-12" data-mp="3ii4qhxkeukmg" />
        <FinalCta data-id="element-13" data-mp="3mlavz2zp87rv" />
      </main>
      <Footer data-id="element-14" data-mp="3mkho1yp07c85" />
    </div>;
}